import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Label,
  Input,
} from 'reactstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import {
  userIsAdmin,
  userIsManager,
} from '../../helpers/Auth';
import { canUserManageShare } from '../../helpers/Share';
import { userHasFeature } from '../../helpers/Features';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

const ShareModalWatermark = ({
  watermark,
  watermarkEnabled,
  handleChange,
  handleClose,
}) => {
  const intl = useIntl();

  return (
    <div className="share-watermark share-setting">
      <Label for="inpWatermark" className={classnames('switch', { disabled: !watermarkEnabled || !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Watermark images' })}
          <HelpIcon id="share-watermark">
            {intl.formatMessage({ defaultMessage: 'Add your workspace watermark to images in this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-watermark" simple={true} />
          {!watermarkEnabled && (
            <HelpIcon id="share-status-change-disabled" permanent={true}>
              {intl.formatMessage({ defaultMessage: 'Watermark not set for this workspace' })}
            </HelpIcon>
          )}
          {userHasFeature('share-watermark') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="watermark"
                id="inpWatermark"
                disabled={!watermarkEnabled || !canUserManageShare()}
                value={true}
                checked={watermark}
                onChange={handleChange}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
      {((userIsAdmin() || userIsManager()) && !watermarkEnabled) && (
        <div className="restricted-notice">
          {intl.formatMessage({ defaultMessage: 'Add a watermark in your <link>workspace settings</link>' }, {
            link: (msg) => (
              <Link to="/admin/settings/watermark" onClick={handleClose}>
                {msg}
              </Link>
            ),
          })}
        </div>
      )}
    </div>
  );
};

ShareModalWatermark.propTypes = {
  watermark: PropTypes.bool.isRequired,
  watermarkEnabled: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ShareModalWatermark;
